import { render } from "./PdfPageViewer.vue?vue&type=template&id=d9b9cf74&scoped=true"
import script from "./PdfPageViewer.vue?vue&type=script&lang=js"
export * from "./PdfPageViewer.vue?vue&type=script&lang=js"

import "./PdfPageViewer.vue?vue&type=style&index=0&id=d9b9cf74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9b9cf74"]])

export default __exports__